<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import { getRadarList } from '@/api/modules/home'
import stock from './components/stock.vue'
import work from './components/work.vue'

definePage({
  name: 'money-flow',
  meta: {
    title: '资金流向',
  },
})
const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([

  {
    name: '自选',
    val: 0,
  },
  {
    name: '行业',
    val: 1,
  },
  {
    name: '个股',
    val: 2,
  },
])

const type = ref(0)

function onTabChange(val: any) {
  type.value = Number(val ? 0 : 1)
  nextTick(() => {
    if (refsList.value) {
      refsList.value.reLoad()
    }
    onLoad()
  })
}

const components: any = {
  0: stock,
  1: work,
  2: stock,
}

const list = ref([])
const loading = ref(false)
const finished = ref(false)
async function onLoad() {
  try {
    const { status, data } = await getRadarList({
      page: 1,
      type: type.value,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page" :search="false">
    <template #navbar-end />
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <Notice />
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
    </div>

    <div class="h-[100%] bg-[#FFFFFF]">
      <div :style="{ height: `${tabContenHeight}px` }" />
      <!-- <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="bg-[#fff]">
          <vxe-table header-row-class-name="table-header" :data="list">
            <vxe-column field="name" title="名称" width="25%" />
            <vxe-column field="data" title="净流入" width="25%" align="center" sortable>
              <template #default="{ row }">
                <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                  {{ row.data }}
                </div>
              </template>
            </vxe-column>
            <vxe-column field="data" title="涨幅" width="25%" align="right">
              <template #default="{ row }">
                <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                  {{ row.data }}
                </div>
              </template>
            </vxe-column>
            <vxe-column field="data" title="净流入率" width="25%" align="right">
              <template #default="{ row }">
                <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                  {{ row.data }}
                </div>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </van-list> -->
      <component :is="components[active]" ref="refsList" v-model:type="active" />
    </div>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
